import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/types-known authors & contributors
// SPDX-License-Identifier: Apache-2.0
import BN from 'bn.js';
import networks from '@polkadot/networks';
import { assert, hexToU8a } from '@polkadot/util';
import kusama from "./kusama.mjs";
import polkadot from "./polkadot.mjs";
import westend from "./westend.mjs"; // testnets are not available in the networks map

var NET_EXTRA = {
  westend: {
    genesisHash: ['0xe143f23803ac50e8f6f8e62695d1ce9e4e1d68aa36c1cd2cfd15340213f3423e']
  }
};
/** @internal */

function checkOrder(network, versions) {
  var ooo = versions.filter(function (curr, index) {
    var prev = versions[index - 1];
    return index === 0 ? false : curr[0] <= prev[0] || curr[1] <= prev[1];
  });
  assert(!ooo.length, "".concat(network, ": Mismatched upgrade ordering: ").concat(JSON.stringify(ooo)));
  return versions;
}
/** @internal */


function mapRaw(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      network = _ref2[0],
      versions = _ref2[1];

  var chain = networks.find(function (n) {
    return n.network === network;
  }) || NET_EXTRA[network];
  assert(chain, "Unable to find info for chain ".concat(network));
  return {
    genesisHash: hexToU8a(chain.genesisHash[0]),
    network: network,
    versions: checkOrder(network, versions).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          blockNumber = _ref4[0],
          specVersion = _ref4[1];

      return {
        blockNumber: new BN(blockNumber),
        specVersion: new BN(specVersion)
      };
    })
  };
} // Type overrides for specific spec types & versions as given in runtimeVersion


var upgrades = Object.entries({
  kusama: kusama,
  polkadot: polkadot,
  westend: westend
}).map(mapRaw);
export default upgrades;